import axios from "axios";
import { appBaseUrl } from "../constants";

const requestInterceptor = (config) => {
    const headers = { 'authorization': `Bearer ${localStorage.getItem('access_token')}` }
    return {
        ...config,
        headers: {
            ...config.headers,
            ...headers
        },
    }
};

class HttpClient {
    constructor() {
        const options = { baseURL: appBaseUrl };
        const instance = axios.create(options);
        instance.interceptors.request.use(requestInterceptor);
        instance.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                if (error?.response?.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                } 
                return Promise.reject(error);
            }
        );
        return instance;
    }
}
export default HttpClient;